import { MissedActivitiesJustifications } from 'presentation/app/modules/Reports/pages/activities/missed-activities-justifications';

export const MakeMissedActivitiesJustifications: React.FC = () => {
  return <MissedActivitiesJustifications />;
};
